import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { edgeHivas, EdgeHiba } from '../lib/edge.ts';
import type { TagSzerep } from '../lib/tipusok.ts';
import { Gomb } from '../ui/elemek.tsx';
import { meghivoKijelzes, type Meghivo } from './meghivoAllapot.ts';
import { MEGHIVAS_ALAP_HIBA, MEGHIVAS_HIBA_SZOVEG } from './weboldalKollegak.ts';

/** Percenként frissülő „most”, hogy a hátralévő idő és a lejárat oldalfrissítés nélkül is változzon. */
function useMost(): Date {
  const [most, setMost] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setMost(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);
  return most;
}

/** Az el nem fogadott meghívó állapota és az újraküldés gombja egy kolléga sorában. */
export default function MeghivoBlokk({ meghivo, officeId, email, nev, szerep, aktiv }: {
  meghivo: Meghivo; officeId: string; email: string; nev: string; szerep: TagSzerep; aktiv: boolean;
}) {
  const qc = useQueryClient();
  const most = useMost();
  const k = meghivoKijelzes(meghivo, most);
  const ujrakuldes = useMutation({
    // Ugyanaz a végpont, mint az új meghívásé: a még el nem fogadott címre új meghívót küld (_shared/meghivas.ts).
    mutationFn: () => edgeHivas('admin-meghivas', { officeId, email, nev, szerep }),
    onSettled: () => qc.invalidateQueries({ queryKey: ['kollegak-meghivok', officeId] }),
  });
  const hiba = ujrakuldes.error
    ? (ujrakuldes.error instanceof EdgeHiba ? (MEGHIVAS_HIBA_SZOVEG[ujrakuldes.error.kod] ?? MEGHIVAS_ALAP_HIBA) : MEGHIVAS_ALAP_HIBA)
    : null;

  return (
    <div className={`grid gap-2 rounded-xl border px-3.5 py-3 text-sm ${k.lejart ? 'border-hiba bg-hiba-hatter text-hiba' : 'border-vonal bg-felulet text-szoveg-halk'}`}>
      <p role="status">{ujrakuldes.isSuccess && !k.lejart ? `Új meghívót küldtünk. ${k.szoveg}` : k.szoveg}</p>
      {/* Inaktív tagnál az újraküldés újra is aktiválná (tagsagMentes), ezért ott előbb aktiválni kell. */}
      {aktiv && (
        <div>
          <Gomb valtozat={k.lejart ? 'elsodleges' : 'masodlagos'} toltes={ujrakuldes.isPending} onClick={() => ujrakuldes.mutate()}>
            Meghívó újraküldése
          </Gomb>
        </div>
      )}
      {hiba && <p role="alert" className="text-hiba">{hiba}</p>}
    </div>
  );
}
